export default function HelperFactory(module) {
    angular.module(module || 'app')
        .factory('helper', helper);
    helper.$inject = ['$window', '$rootScope', '$q', '$timeout'];
    var userPromise;
    var scripts = [];
    var googleApiPromise;

    function helper($window, $rootScope, $q, $timeout) {
        return {
            getMediaQueries: getMediaQueries,
            getMediaQuery: getMediaQuery,
            getLoadingIndicator: getLoadingIndicator,
            getCurrentMediaQuery: getCurrentMediaQuery,
            getResponsiveValue: getResponsiveValue,
            alert: alert,
            loadScript: loadScript,
            loadGoogleScripts: loadGoogleScripts
        };

        function getMediaQueries() {
            var queries = angular.element('meta.foundation-mq').css('fontFamily').replace('"', '').replace("'", '').split('&');
            var mediaQueries = {};
            for (var i = 0; i < queries.length; i++) {
                var pieces = queries[i].split('=');
                var key = pieces[0];
                var size = parseFloat(pieces[1]);
                mediaQueries[key] = $window.matchMedia('only screen and (min-width: ' + size + 'em)');
                mediaQueries[key + ' down'] = $window.matchMedia('only screen and (max-width: ' + size + 'em)');
                var nextSize;
                if (i < queries.length - 1) {
                    var nextPieces = queries[i + 1].split('=');
                    var query = 'only screen and ';
                    if (size) {
                        query += '(min-width: ' + size + 'em) and ';
                    }
                    query += '(max-width: ' + parseFloat(nextPieces[1]) + 'em';
                    mediaQueries[key + ' only'] = $window.matchMedia(query);
                }
            }
            return mediaQueries;
        }

        function getMediaQuery(key) {
            var mediaQueries = getMediaQueries();
            return mediaQueries[key];
        }

        function getLoadingIndicator() {
            return angular.element('<span class="fa fa-spin fa-spinner loader"></span>');
        }

        function getCurrentMediaQuery() {
            if (Foundation.MediaQuery.current) {
                return Foundation.MediaQuery.current;
            }
            var queries = getMediaQueries();
            var keys = Object.keys(queries);
            var result;
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                if (queries[key].matches) {
                    result = key;
                }
                else {
                    break;
                }
            }
            return result;
        }

        function alert(title, text) {
            $rootScope.alert = {
                title: title,
                text: text.indexOf('<') === 0 ? text : '<p>' + text + '</p>'
            };
            $rootScope.$evalAsync(function () {
                angular.element('#alert').foundation('open');
            });
        }

        function getResponsiveValue(value) {
            if (Foundation.MediaQuery.queries.length < 2) {
                Foundation.MediaQuery._reInit();
            }
            if (!value || typeof (value) !== 'object') {
                return value;
            }
            if (('large' in value) && Foundation.MediaQuery.atLeast('large')) {
                return value.large;
            }
            if (('medium' in value) && Foundation.MediaQuery.atLeast('medium')) {
                return value.medium;
            }
            if ('small' in value) {
                return value.small;
            }
            return null;
        }


        function loadScript(source) {
            var scriptFound = !!scripts[source];
            if (!scriptFound) {
                var script = document.createElement('script');
                script.async = 1;
                script.src = source;
                document.querySelector('head').appendChild(script);
            }
            return scriptFound;
        }

        function loadGoogleScripts(apiKey) {
            if (googleApiPromise) {
                return googleApiPromise;
            }
            var deferred = $q.defer();
            googleApiPromise = deferred.promise;
            var scripts = [
                'https://maps.googleapis.com/maps/api/js?libraries=places&callback=_initGoogleApi&key=' + apiKey
            ];
            var remainingScripts = scripts.length;
            $window._initGoogleApi = () => {
                remainingScripts--;
                if (remainingScripts === 0) {
                    deferred.resolve();
                }
            }
            scripts.forEach(script => loadScript(script));
            return googleApiPromise;
        }
    }
};